import {Navigate, Outlet} from "react-router-dom";
import {useContext} from "react";
import {AuthContext} from "../context/AuthProvider";

interface Props {
    isAuthenticated: boolean;
}

const ProtectedRoute = ({isAuthenticated}: Props) => {
    const {login} = useContext(AuthContext);

    if (!isAuthenticated) {
        login();
        return <Navigate to="/" replace/>;
    }

    return <Outlet/>;
};

export default ProtectedRoute;